<template>
  <button :disabled="disabled" @click="$emit('click')" class="loadMore">
    Next {{count}}
    <icon-base :gray="disabled" :red="!disabled">
      <icon-arrow-max bottom/>
    </icon-base>
  </button>
</template>

<script>
import { IconArrowMax } from 'Icons';

export default {
  props: {
    disabled: Boolean,
    count: {
      type: Number,
      required: true,
    },
  },
  components: {
    IconArrowMax,
  },
};
</script>


<style lang="scss" scoped>
.loadMore {
  @include removeBtnDefaults;
  @include font(13px, $red-color3);
  font-weight: 500;
  &[disabled] {
    cursor: not-allowed;
    color: $grey-color2;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/uikit/LoadMoreBtn.vue